import React from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { StaticQuery, graphql } from 'gatsby'
import { Link } from 'gatsby'


class SslGratis extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 170px 0 150px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 100px 0 50px 0;              
            }
        `

        const ServiceHeadinga = styled(Link)`
            font-family: Oswald;
            color: #00a648;
            font-size: 30px;
            line-height: 30px;
            text-align: center !important;
            transition: .5s;
            &:hover {
              color: #1a1a1a;
              text-decoration: none;
            }
        `

        const ServiceHeadingaP = styled(Link)`
            font-family: Oswald;
            color: #00a648;
            font-size: 25px;
            line-height: 30px;
            text-align: center !important;
            transition: .5s;
            &:hover {
              color: #1a1a1a;
              text-decoration: none;
            }
        `

        const Heading2 = styled.h2`
            font-size: 70px;
            font-family: Poppins;
            color: #1a1a1a;
            line-height: 80px;
            text-align: center;
            font-weight: bold;
            padding-bottom: 80px;            
            @media (max-width: 767px) {
                font-size: 50px;           
            }
        `
        const Heading3 = styled.h3`
            text-align: center !important;
            @media (max-width: 767px) {
                font-size: 40px;           
            }
        `

        const ServiceCol = styled(Col)`
            padding: 0;
            border-right: #444;
            &.no-border {
                border-right: none;
            }
            @media (max-width:500px) {
                border-right:none;
            }
        `

        const Service = styled.div`
            min-height: 300px;
            background-color: #fff;
            transition: .2s;
            display: flex;
            justify-content: center;
            flex-direction: column;
            &:hover {
                background-color: #c1eb18;                
            }
        `
        const ServiceContent = styled.div`
            padding: 40px;
            color: #fff;
        `

        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 10px;
            text-align: center !important;            
        `

        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #444;
        `
        const TyCText = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #444;
        `
        const Text = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #444;
        `

        return (
            <Section>
                <Container>
                    <Row>
                        <Col md={12}>
                            <Heading2>Certificado SSL Gratis</Heading2>
                        </Col>
                        <Text>Disfruta SSL gratis incluido en todos nuestros planes de hosting para mayor seguridad y confianza. También ofrecemos
                            certificados de RapidSSL, GeoTrust, Sectigo, DigiCert o SAN, con prueba de 90 días gratis para RapidSSL Trial.
                        </Text>
                    </Row>
                    <Row>
                        <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                            <Service>
                                <ServiceContent>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image1} alt="RapidSSL GRATIS en Colombia" />
                                    </ServiceIcon>
                                    <Heading3>
                                        <ServiceHeadinga to="/rapidssl"
                                            onClick={() => {
                                                window.gtag('event', 'click_button_ssl_gratis', {
                                                    button_name: 'SSL GRATIS A',
                                                    destination_url: '/rapidssl'
                                                });
                                            }}>
                                            Certificado RapidSSL Gratis 1 año
                                        </ServiceHeadinga>
                                    </Heading3>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Compre un certificado RapidSSL Standard por 2 años y lleve gratis un año. 2 años por el precio de uno.
                                    </ServiceText>
                                    <TyCText>
                                        Usando el cupón segundo0
                                    </TyCText>
                                    <Heading3>
                                        <ServiceHeadingaP to="/rapidssl"
                                            onClick={() => {
                                                window.gtag('event', 'click_button_ssl_gratis', {
                                                    button_name: 'SSL GRATIS B',
                                                    destination_url: '/rapidssl'
                                                });
                                            }}>
                                            Certificado Digital Gratis
                                        </ServiceHeadingaP>
                                    </Heading3>
                                </ServiceContent>
                            </Service>
                        </ServiceCol>
                        <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                            <Service>
                                <ServiceContent>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image1} alt="SSL GeoTrust True BusinessID SAN GRATIS en Bogotá" />
                                    </ServiceIcon>
                                    <Heading3>
                                        <ServiceHeadinga to="/ssl-geotrust"
                                            onClick={() => {
                                                window.gtag('event', 'click_button_SAN_gratis', {
                                                    button_name: 'SSL SAN GRATIS 1 año A',
                                                    destination_url: '/ssl-geotrust'
                                                });
                                            }}>
                                            GeoTrust SAN (Flex) Gratis 1 año
                                        </ServiceHeadinga>
                                    </Heading3>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Compre un SSL GeoTrust True BusinessID SAN (Validación OV) por 2 años y lleve gratis un año. 2 años x uno.
                                    </ServiceText>
                                    <TyCText>
                                        Usando el cupón segundo0
                                    </TyCText>
                                    <Heading3>
                                        <ServiceHeadingaP to="/ssl-geotrust"
                                            onClick={() => {
                                                window.gtag('event', 'click_button_SAN_gratis', {
                                                    button_name: 'SSL SAN GRATIS 1 año B',
                                                    destination_url: '/ssl-geotrust'
                                                });
                                            }}>
                                            SSL Gratis
                                        </ServiceHeadingaP>
                                    </Heading3>
                                </ServiceContent>
                            </Service>
                        </ServiceCol>
                        <ServiceCol md={4}>
                            <Service>
                                <ServiceContent>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image2} alt="SSL de prueba Gratis de 90 días en Medellín Colombia" />
                                    </ServiceIcon>
                                    <Heading3>
                                        <ServiceHeadinga to="/conecta"
                                            onClick={() => {
                                                window.gtag('event', 'click_button_90_gratis', {
                                                    button_name: 'SSL 90 GRATIS A',
                                                    destination_url: '/conecta'
                                                });
                                            }}>
                                            SSL de prueba Gratis de 90 días
                                        </ServiceHeadinga>
                                    </Heading3>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Pruebe un certificado digital RapidSSL Trial de validación de dominio (DV) durante 90 días GRATIS.
                                    </ServiceText>
                                    <TyCText>
                                        Contáctenos
                                    </TyCText>
                                    <Heading3>
                                        <ServiceHeadingaP to="/conecta"
                                            onClick={() => {
                                                window.gtag('event', 'click_button_90_gratis', {
                                                    button_name: 'SSL 90 GRATIS B',
                                                    destination_url: '/conecta'
                                                });
                                            }}>
                                            SSL Gratis 90 días
                                        </ServiceHeadingaP>
                                    </Heading3>
                                </ServiceContent>
                            </Service>
                        </ServiceCol>
                    </Row>
                </Container>
            </Section>
        )
    }

}
const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "icons/ssl-gratis.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/ssl-90-dias.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }          
        }
      `}
        render={(data) => {
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            return <SslGratis data={data} image1={image1} image2={image2}{...props} />;
        }}
    />
);

export default Iconos;
